import { getDefaultPeriodPresets } from '~shared/ui/date-range-picker';

import {
  getDefaultPeriodMaxDate,
  getDefaultPeriodMinDate,
} from '~features/period-filter';

export const PERIOD_PRESETS = getDefaultPeriodPresets();

export const PERIOD_MIN_DATE = getDefaultPeriodMinDate();

export const PERIOD_MAX_DATE = getDefaultPeriodMaxDate();
